import styled from "styled-components";

export const HomePageContainer = styled.div`
  padding: 2rem 2rem 2rem 2rem;
  display: flex;
  flex-direction: column;
  width: 100%;

  .placeholder-text {
    font-size: var(--font-size-base);
    color: var(--color-text-secondary);
    text-align: center;
    margin-top: 4rem;
  }
`;
